<template>
    <ImageUpload
        v-if="field.options.config.type == 'image'"
        :fileList="fileList"
        :isShowUploadBtn="!isRead"
        :isRead="isRead"
        @success="handleSetFile"
        @remove="handleSetFile"
    />
    <FileUpload
        v-else
        :fileList="fileList"
        :isShowUploadBtn="!isRead"
        :isRead="isRead"
        :showFileList="showFileList"
        :isFormDetail="isFormDetail"
        :formBtnAuth="formBtnAuth"
        :formData="formData"
        :formId="formId"
        :key="loadTimer"
        :isFromSubForm="isFromSubForm"
        @success="handleSetFile"
        @remove="handleSetFile"
        @previewFile="handlePreviewFile"
    />
</template>

<script>
    import { cloneDeep, isEmpty } from 'lodash';
    import { API_IMG_DOWNLOAD } from '@/common/constants';
    import { getPreviewFileUrl } from '@/utils/grocer';
    import { compareDateData } from '@/utils/date';
    export default {
        data () {
            return {
                fileList: [],
                loadTimer: ''
            };
        },
        props: {
            selectFiles: {
                type: [ Array, String ]
            },
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isFormDetail: {
                type: Boolean,
                default: false
            },
            showFileList: {
                type: Boolean,
                default: true
            },
            formBtnAuth: {
                type: Object
            },
            formId: {
                type: String
            },
            isFromSubForm: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            formField: {
                set (newVal, oldVal) {
                    this.formData[this.field.formField] = newVal;
                    // console.log(newVal);
                    let viewArr = newVal;
                    let viewData = [];
                    for (var i = 0; i < viewArr.length; i++) {
                        viewData.push(viewArr[i].fileName);
                    }
                    // console.log(viewData.join(','));
                    this.formData[this.field.formField + '-view'] = viewData.join(','); // 针对选项、下拉进行名称赋值(多选)
                },
                get (val) {
                    return this.formData[this.field.formField];
                }
            }
        },
        created () {
            this._setDefaultFiles();
        },
        methods: {
            _setDefaultFiles (defaultFile) {
                let resDataList;
                this.fileList = [];
                if (Array.isArray(this.selectFiles)) {
                    resDataList = this.selectFiles;
                } else if (Array.isArray(defaultFile)) {
                    resDataList = this.selectFiles;
                } else {
                    resDataList = [];
                }
                if (this.field.options.config.type === 'image') {
                    let allImgExt = '.jpg|.jpeg|.gif|.bmp|.png|'; // 全部图片格式类型
                    resDataList.forEach(file => {
                        let imageExt = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
                        if (imageExt && allImgExt.indexOf(imageExt) > -1) {
                            if (!file.url) {
                                file.url = `${API_IMG_DOWNLOAD}${file.filePath}`;
                            }
                            this.fileList.push(this.setFileInfo(file));
                        }
                    });
                } else {
                    this.fileList = resDataList;
                }
                // if (!isEmpty(this.fileList)) {
                //     let compareList = this.fileList.sort(compareDateData('createDate', false));// 目前暂时以降序进行排序
                //     this.fileList = compareList;
                // }
            },
            handleSetFile (params) {
                let fileValues = [];
                try {
                    if (params && params.fileList) {
                        let fileLists = cloneDeep(params.fileList);
                        fileLists.forEach(file => {
                            if (file.status && file.status === 'success') {
                                if (file.response && file.response.data) {
                                // 本次上传的文件
                                    let resDataList = cloneDeep(file.response.data);
                                    resDataList.forEach(resFile => {
                                        if (this.field.options.config.type === 'image') {
                                            resFile.url = `${API_IMG_DOWNLOAD}${resFile.filePath}`;
                                        }
                                        fileValues.push(this.setFileInfo(resFile));
                                        file.createDate = resFile.createDate;
                                    });
                                } else {
                                    fileValues.push(this.setFileInfo(file));
                                }
                            } else {
                                // 以前上传完成，并保存的文件
                                fileValues.push(this.setFileInfo(file));
                            }
                        });
                        fileValues = fileValues.sort(compareDateData('createDate', false));// 目前暂时以降序进行排序
                        this.loadTimer = new Date().getTime();
                    }
                    this.fileList = fileValues;
                    this.formField = fileValues;
                    this.$emit('dealFileData', this.field.id);
                } catch (error) {
                    console.error(error);
                }
            },
            setFileInfo (obj) {
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    currentUserStr = JSON.parse(currentUserStr);
                    let param = {
                        name: obj.fileName,
                        url: obj.url,
                        fileName: obj.fileName,
                        fileByteSize: obj.fileByteSize,
                        filePath: obj.filePath,
                        createDate: obj.createDate,
                        createPeople: obj.createPeople
                    };
                    if (obj.createdBy) {
                        param.createdBy = obj.createdBy;
                    }
                    if (!obj.uid) {
                        param.createdBy = currentUserStr.userId;
                    }
                    return param;
                } else {
                    this.$message.error('请重新登录');
                }
            },
            async handlePreviewFile (file) {
                // console.log(file);
                let previewUrl = await getPreviewFileUrl(file);
                if (previewUrl) {
                    let tempwindow = window.open();
                    tempwindow.location = previewUrl;
                }
            }
        }
    };
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/FieldItem/FieldItemFile.vue